export default __webpack_public_path__ + "static/media/Verizon_Media-Logo.wine.d567c2b2.png";